import type { JSX } from 'react'
export const HashtagsEmptyIllustration = (): JSX.Element => {
  return (
    <svg
      width="200"
      height="100"
      viewBox="0 0 228 141"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g clipPath="url(#clip0_686_64296)">
        <path
          d="M129.448 -0.200195C83.8597 -0.20009 46.8 32.6844 46.7998 73.3682C46.8 73.644 47.024 73.8679 47.2998 73.8682C47.5759 73.8682 47.7997 73.6442 47.7998 73.3682C47.8 33.3436 84.2987 0.79991 129.448 0.799805C174.619 0.799805 211.097 28.9447 211.097 73.3682L211.097 123.115L197.188 110.628C196.982 110.444 196.666 110.461 196.481 110.666C196.297 110.871 196.314 111.188 196.52 111.372L211.215 124.565C211.405 124.736 211.692 124.735 211.882 124.565L226.62 111.372C226.826 111.188 226.843 110.872 226.659 110.666C226.475 110.461 226.16 110.444 225.954 110.627L212.097 123.032L212.097 73.3682C212.097 28.2485 175.016 -0.200195 129.448 -0.200195Z"
          fill="var(--color-illustration-element)"
        />
        <rect
          x="0.5"
          y="89.5"
          width="183"
          height="51"
          rx="4.5"
          fill="var(--color-illustration-card)"
        />
        <rect
          x="0.5"
          y="89.5"
          width="183"
          height="51"
          rx="4.5"
          stroke="var(--color-illustration-border)"
        />
        <rect
          x="40"
          y="107"
          width="113"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <rect
          x="40"
          y="119"
          width="132"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <path
          d="M15 113H28.3333M15 118H28.3333M20 108L18.3333 123M25 108L23.3333 123"
          stroke="var(--color-illustration-element)"
          strokeOpacity="0.4"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="44.5"
          y="25.5"
          width="183"
          height="51"
          rx="4.5"
          fill="var(--color-illustration-card)"
        />
        <rect
          x="44.5"
          y="25.5"
          width="183"
          height="51"
          rx="4.5"
          stroke="var(--color-illustration-border)"
        />
        <rect
          x="84"
          y="43"
          width="104"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <rect
          x="84"
          y="55"
          width="132"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <path
          d="M59 49H72.3333M59 54H72.3333M64 44L62.3333 59M69 44L67.3333 59"
          stroke="var(--color-illustration-element)"
          strokeOpacity="0.4"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_686_64296">
          <rect
            width="228"
            height="141"
            fill="var(--color-illustration-card)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
